import type { ReactNode } from "react";
import { Children } from "react";

type HasButtonProps = {
  label?: ReactNode;
  href?: string;
  onClick?: () => void;
};

export function hasButton({ label, href, onClick }: HasButtonProps): boolean {
  const hasLabel = Children.count(label) > 0;
  return hasLabel && Boolean(href || onClick);
}
